import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from '../styles.module.scss'

export const TextLandRo = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <HighlightedText
            text="325% PÂNĂ LA 25.000 DE RON  + 400 ROTIRI GRATUITE"
            highlights={[{ word: '325%' }, { word: '25.000' }, { word: '400' }]}
            breakAfterWords={isDesktop ? ['LA', 'RON'] : ['RON']}
            className={styles.text_land}
        />
    )
}
